module.exports = __webpack_public_path__ + "onboarding-pkg-Octopack.df4a6ca754a56626ef3a96a369c2246e.hashedasset.svg";